/* tslint:disable */

/**
 */
export class VComponent {
    FREEZE_TEMP?: number;
    AIR?: number;
    CLASS_TYPE?: number;
    COMP_COMMENT?: string;
    COMP_DATE?: string;
    COMP_GEN_STATUS?: number;
    COMP_IMP_ID_STUDY?: number;
    COMP_NATURE?: number;
    COMP_RELEASE?: number;
    COMP_VERSION?: number;
    COND_DENS_MODE?: number;
    DENSITY?: number;
    FAT_TYPE?: number;
    BLS_CODE?: string;
    GLUCID?: number;
    ID_COMP?: number;
    ID_USER?: number;
    LIPID?: number;
    NON_FROZEN_WATER?: number;
    OPEN_BY_OWNER?: number;
    PROTID?: number;
    SALT?: number;
    SPECIFIC_HEAT?: number;
    SUB_FAMILY?: number;
    WATER?: number;
    LABEL?: string;
    LABEL2?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/vcomponent.ts